import { type CountdownOptions } from "@client/lib/jquery/countdown";
import { getDateTimeValue } from "@client/lib/settings";
import {
  combinedSettingsSelector,
  createShallowEqualSelector,
  idPropsSelector,
  isEditModeSelector,
  TargetSelector
} from "@client/selectors";

export const makeCountdownOptionsSelector = () => {
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, ["timerDate", "redirectUrl"]);
  return createShallowEqualSelector(
    [idPropsSelector, isEditModeSelector, settingsSelector],
    (id, isEditMode, settings): CountdownOptions => {
      return {
        localStorageKey: `cartlyCountdown-${id}`,
        type: "fixed",
        date: getDateTimeValue(settings.timerDate) ?? new Date(),
        redirectUrl: settings.redirectUrl && !isEditMode ? settings.redirectUrl : undefined
      };
    }
  );
};
